import { MediaProps } from '#/lib/sanity';
import { SanityLottieAnimation } from '#/lib/sanity/queries/lottieAnimation';
import { cn } from '#/lib/utils';

import { Image } from './Image';
import { InViewLottiePlayer } from './LottiePlayer';

type Props = {
  lottie: SanityLottieAnimation;
} & MediaProps;

export function LottieAnimation({
  lottie,
  className,
  mediaClassName,
  aspect = true,
  style,
  sizes = '100vw',
}: Props) {
  const fallback = (
    <Image
      image={lottie.fallback}
      sizes={sizes}
      aspect={false}
      className="absolute inset-0 size-full"
      mediaClassName="size-full object-cover"
    />
  );

  return (
    <figure
      className={cn(
        'relative overflow-clip',
        lottie.roundedCorners && 'rounded-brand',
        className,
      )}
      style={{
        aspectRatio: aspect ? `${lottie.width} / ${lottie.height}` : undefined,
        ...style,
      }}
    >
      <div className={cn('absolute inset-0 size-full', mediaClassName)}>
        <InViewLottiePlayer
          path={lottie.url}
          loop={lottie.loop}
          fallback={fallback}
          className="size-full"
          style={{ width: '100%', height: '100%' }}
        />
      </div>
    </figure>
  );
}
